export default "__VITE_ASSET__CMG0Ybbt__"